import networkLink from "../util/network-link";

export function common(){
    let deviceCheck = (promokit.store('device')==="pc") ? "/img" : "/img/m";
    promokit.layer({
        image:`${promokit.store('staticPath')}/promo/aion/event/2022/220518_challenge${deviceCheck}/layer-event.jpg`,
        buttons:'.p-btn__reward',
        modifier:'reward'
    });

    $(".p-btn__floating").attr({href:`${networkLink[promokit.store("network")]}/update/history/2022/220518_update`});
    $(".p-btn__guide1").attr({href:`https://aion.plaync.com/guidebook/classic/view?title=%ED%95%B4%EB%B0%A9%EB%90%9C%20%ED%8C%8C%EC%8A%88%EB%A7%8C%EB%94%94%EB%A5%B4%20%EC%82%AC%EC%9B%90`, target:"_blank"});
    $(".p-btn__guide2").attr({href:`https://aion.plaync.com/guidebook/classic/view?title=%EC%8B%AC%EC%97%B0%EC%9D%98%20%EC%9E%94%ED%95%B4`, target:"_blank"});
    $(".p-btn__guide3").attr({href:`https://aion.plaync.com/guidebook/classic/view?title=%EB%9E%AD%ED%82%B9`, target:"_blank"});

    $(document).on('click', '.cases__btn--login', ()=>{promokit.login()});
};

export function promoPage(opt){
    promokit.page(
        $.extend(
            {
                el:'#container',
                type:'basic',
                cnb:true,
                topButton:true,
                footer:{
                    theme:'white'
                },
                headerButton:{
                    home:true,
                    event:true,
                    sns:true,
                    theme:'black'
                },
                caution:{
                    template:
                    `<ol>
                        <li>제재된 계정 및 라이브 서버 캐릭터는 참여가 불가능합니다.</li>
                        <li>미션에 참여할 캐릭터는 한번 선택 후 변경이 불가능하오니 신중하게 선택하시길 바랍니다.</li>
                        <li>미션은 2022. 5. 18.(수) 정기점검 후 ~ 6. 8.(수) 정기점검 전까지 플레이 한 기록이 반영됩니다.</li>
                        <li>당일 06:00 ~ 익일 05:59:59까지 플레이 한 기록이 익일 오전 10:00에 반영됩니다.</li>
                        <li>보상 획득은 2022. 5. 18.(수) 정기점검 후 ~ 6. 15.(수) 정기점검 전까지 가능합니다.</li>
                        <li>가이드북 확인 미션은 [바로 가기] 버튼을 눌러 가이드북을 확인 하셔야 완료가 됩니다.</li>
                        <li>보상 쿠폰은 발급 후 30일 이내 사용 가능하며, 기간이 지난 쿠폰은 사용할 수 없습니다.</li>
                        <li>쿠폰 보상을 이미 수령했을 경우 다른 캐릭터로 이동이 불가능합니다.</li>
                        <li>이벤트 참여 캐릭터 선택 후 캐릭터를 삭제하시거나 부가 서비스를 이용할 경우 더 이상 이벤트 참여가 불가능 합니다.</li>
                        <li>[이벤트]가 적용된 아이템은 공지 후 삭제될 수 있습니다.</li>
                    </ol>`
                }
            },
            opt || {}
        )
    );
};